import { render, staticRenderFns } from "./RecyclableBoxScrap.vue?vue&type=template&id=32d3a708&scoped=true&"
import script from "./RecyclableBoxScrap.vue?vue&type=script&lang=js&"
export * from "./RecyclableBoxScrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d3a708",
  null
  
)

export default component.exports